import type { UserPermissions } from "@/api/resources/auth/types";
import { WorkspaceRole, type Workspace } from "@/supabase.types";
import { byKey, filterNotEmpty } from "@/utils/format";

export const selectorDirectAccessWorkspaces = (workspaces: Workspace[], userPermissions?: UserPermissions | null) => {
  if (userPermissions?.globalAdmin) return workspaces;
  if (!userPermissions?.workspace) return [];

  const _utw = userPermissions.workspace.filter(({ role }) => {
    if (role === WorkspaceRole.admin || role === WorkspaceRole.viewer) return true;
    return false;
  });

  return _utw
    .map(({ workspace_id }) => workspaces.find(({ id }) => id === workspace_id))
    .filter(filterNotEmpty)
    .filter(({ deleted_at }) => deleted_at === null);
};

export const selectorWorkspacesByKey = (workspaces: Workspace[]) => {
  return byKey(workspaces, "id");
};
